import { api } from './api';

export interface Lab { id: string; name: string; inCharge: string | null; isActive: boolean; itemCount: number; }
export interface LabItem { id: string; labId: string; name: string; code: string | null; quantity: number; unitCostPaise: number; notes: string | null; }
export interface Breakage { id: string; itemName: string; quantity: number; studentName: string | null; reason: string | null; charged: boolean; chargedPaise: number; createdAt: string; }

export const labsApi = {
  list: () => api.get<Lab[]>('/api/labs'),
  create: (b: { name: string; institutionId: string; inCharge: string | null }) => api.post<Lab>('/api/labs', b),
  update: (id: string, b: { name: string; inCharge: string | null; isActive: boolean }) => api.put<Lab>(`/api/labs/${id}`, b),

  items: (labId: string) => api.get<LabItem[]>(`/api/labs/${labId}/items`),
  addItem: (b: { labId: string; name: string; code: string | null; quantity: number; unitCostPaise: number; notes: string | null }) => api.post<LabItem>('/api/labs/items', b),
  updateItem: (id: string, b: { name: string; code: string | null; unitCostPaise: number; notes: string | null }) => api.put<LabItem>(`/api/labs/items/${id}`, b),
  restock: (id: string, by: number) => api.post<LabItem>(`/api/labs/items/${id}/restock`, { by }),
  deleteItem: (id: string) => api.del<void>(`/api/labs/items/${id}`),

  breakage: (labId: string) => api.get<Breakage[]>(`/api/labs/${labId}/breakage`),
  logBreakage: (b: { labItemId: string; quantity: number; studentId: string | null; reason: string | null; charge: boolean; chargePaise: number | null }) =>
    api.post<Breakage>('/api/labs/breakage', b),
};
